import React from 'react'
// import { FiChevronRight, FiChevronLeft } from "react-icons/fi";

function Dance() {
  const dance = [
    {
      id: 1,
      src: "https://res.cloudinary.com/dkqxnquga/image/upload/v1693988292/sailendra_zdkiul.jpg",
      speaker: "SAILENDRA SAMANTRAY",
      designation: "Dancer-Actor",
      workshop: "Dance Workshop",
      date: "Date:9th September 2023",
      venue: "Venue:BBA,Nit Rourkela",
    },
    // {
    //   id: 2,
    //   src: "https://res.cloudinary.com/dkqxnquga/image/upload/v1693988294/Poppin_fxr5v0.jpg",
    //   speaker: "POPPIN DIBYA",
    //   designation: "Dancer",
    //   workshop: "Dance Workshop",
    //   date: "Date:9th September 2023",
    //   venue: "Venue:BBA,Nit Rourkela",
    // },
    // {
    //   id: 3,
    //   src: "https://res.cloudinary.com/dkqxnquga/image/upload/v1693989589/aditya_ytl8dj.jpg",
    //   speaker: "ADITYA MOHANTY ",
    //   designation: "Odissi Dancer",
    //   workshop: "Odissi Dance Workshop",
    //   date: "Date:9th September 2023",
    //   venue: "Venue:BBA,Nit Rourkela",
    // },
  ];

  //  const scrollLeft = () => {
  //    document.getElementById("content").scrollLeft -= 400;
  //  };
  //  const scrollRight = () => {
  //    document.getElementById("content").scrollLeft += 400;
  //  };

  return (
    <div className=" dance bg-[#B3B3B3]  w-full min-h-screen relative ">
      {/* Category */}
      <div className=" pt-20 lg:pt-32 px-auto lg:pl-10 w-fit h-1/3 relative">
        <img
          src="https://res.cloudinary.com/dkqxnquga/image/upload/v1693719224/Group_9_1_bk2fxa.png"
          alt="dance"
        ></img>
        <h1 className=" absolute text-outfit text-white text-6xl sm:text-9xl lg:text-[200px] font-black bottom-2 left-[22%] md:left-[25%] lg:left-28 xl:left-20 tracking-widest">
          DANCE
        </h1>
      </div>

      {/* Workshop Description */}

      
        {dance.map(
          ({ id, src, speaker, designation, workshop, date, venue }) => (
            <div key={id} className="w-full h-1/3 sm:max-w-2xl lg:max-w-xl xl:max-w-3xl flex flex-col md:flex-row items-center justify-start text-outfit mt-10 mb-2 mx-auto xl:ml-10 ">
             
              <div className=" w-40 h-40 md:w-64 md:h-64 xl:w-80 xl:h-80 ] bg-no-repeat bg-cover bg-center rounded-full border-8 border-[#999999]  hover:scale-110 duration-150 ">
                <img
                  src={src}
                  alt="music"
                  className="w-full h-full rounded-full"
                />
              </div>

              <div className=" text-center md:text-left text-white h-2/3  mt-6 md:ml-10 ">
                <h className="text-3xl md:text-6xl lg:text-4xl font-extrabold ">
                  {speaker}
                </h>
                <h1 className="text-2xl md:text-5xl  lg:text-3xl font-bold ">
                  {designation}
                </h1>
                <br />
                <div className="text-md md:text-2xl lg:text-xl font-semibold leading-none">
                  <h1>{workshop}</h1>
                  <h1>{date}</h1>
                  <h1>{venue}</h1>
                </div>
              </div>
              
            </div>
          )
        )}
     

      {/* Category Image*/}
      <div className=" sm:ml-[10%]  lg:ml-[18%] xl:absolute xl:bottom-2 xl:right-0 ">
        <img
          src="https://res.cloudinary.com/dkqxnquga/image/upload/v1693933261/image_1_idxqbc.png"
          alt="DANCE"
        ></img>
      </div>
    </div>
  );
}

export default Dance